export default __webpack_public_path__ + "static/brand-logo-fallback-b17ee761edc2f875e3bdff414037b449.png";